/** Re-exported from the shared drawer shell (kept here for existing importers). */
export { NAVBAR_HEIGHT } from '../drawer/drawer.constants';

/** Alpha levels for primary-color-based backgrounds, borders and shadows. */
export const PRIMARY_ALPHA = {
  sectionBg: 0.04,
  sectionBorder: 0.1,
  itemBg: 0.06,
  itemBgHover: 0.1,
  itemShadow: 0.12,
  itemShadowHover: 0.18,
  itemBorder: 0.4,
  itemBorderHover: 0.65,
  buttonBorder: 0.35,
  buttonBgHover: 0.06,
  applyShadow: 0.35,
  applyShadowHover: 0.45,
} as const;

/** Alpha levels for warning/error banners. */
export const WARNING_ALPHA = {
  bg: 0.07,
  border: 0.2,
} as const;

/** DOM data-attributes shared between JSX spreads and querySelectorAll calls. */
export const DATA_ATTRS = {
  columnList: 'data-column-list',
  columnKey: 'data-column-key',
} as const;
